import { MapTilerBaseLayerBase } from "./MapTilerBaseLayerBase";
export class MapTilerCyclingLayer extends MapTilerBaseLayerBase {
    constructor() {
        super(MapTilerCyclingLayer.Url);
    }
    onAfterFetch(style) {
        MapTilerBaseLayerBase.removeLayers(style, ["road_oneway", "road_oneway_opposite"]);
        // Add cycleway and 'highway=path;bicycle=designtated' in bright blue
        MapTilerCyclingLayer.addLayer(style, {
            id: "road_cycleway",
            type: "line",
            paint: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "line-color": "#0000ff",
                "line-opacity": 0.5,
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.55,
                    stops: [
                        [4, 1],
                        [20, 6],
                    ],
                }
            },
            filter: [
                "any",
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "subclass", "cycleway"],
                ],
                [
                    "all",
                    ["==", "$type", "LineString"],
                    ["in", "bicycle", "designated", "yes"],
                    ["in", "class", "path"],
                ],
            ],
            layout: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "line-cap": "square",
                "line-join": "bevel",
            },
            source: "openmaptiles",
            "source-layer": "transportation",
        }, "bridge_major");
        // Add 'cycleway=track' on major roads in dotted, blue
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-cycleway-lane",
            type: "line",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 14,
            paint: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "line-color": "#0000ff",
                "line-opacity": 0.5,
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.55,
                    stops: [
                        [4, 1],
                        [20, 6],
                    ],
                },
                "line-gap-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.4,
                    stops: [
                        [6, 0.5],
                        [20, 20],
                    ],
                },
                "line-dasharray": [1, 1],
            },
            filter: [
                "all",
                ["in", "cycleway", "lane", "track"],
                ["!=", "subclass", "cycleway"],
            ],
        }, "bridge_major");
        // Add cyclestreets in bright blue
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-cyclestreet",
            type: "line",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 14,
            paint: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "line-color": "#0000ff",
                "line-opacity": 0.5,
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.55,
                    stops: [
                        [4, 3],
                        [20, 10],
                    ],
                },
                //"line-dasharray": [1, 1],
            },
            filter: ["all", ["==", "cyclestreet", "yes"]],
        }, "bridge_major");
        // Add dotted cycleways (with offset) if they are on the right
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-cycleway-lane-right",
            type: "line",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 14,
            paint: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "line-color": "#0000ff",
                "line-opacity": 0.5,
                "line-width": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.55,
                    stops: [
                        [4, 1],
                        [20, 6],
                    ],
                },
                "line-offset": {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    /* @ts-ignore */
                    base: 1.4,
                    stops: [
                        [6, 0.25],
                        [20, 10],
                    ],
                },
                "line-dasharray": [1, 1],
            },
            filter: [
                "all",
                ["in", "cycleway:right", "lane", "track"],
                ["!=", "subclass", "cycleway"],
            ],
        }, "bridge_major");
        const bicycleOneway = ["any",
            ["==", "anyways:oneway:bicycle", 1],
            ["all",
                ["!has", "anyways:oneway:bicycle"],
                ["==", "oneway:bicycle", 1]
            ],
            ["all",
                ["!has", "anyways:oneway:bicycle"],
                ["!has", "oneway:bicycle"],
                ["==", "oneway", 1]
            ]
        ];
        const noOnewayBicycle = ["any",
            ["==", "anyways:oneway:bicycle", 0],
            ["all",
                ["!has", "anyways:oneway:bicycle"],
                ["==", "oneway:bicycle", 0]
            ]
        ];
        const onewayButNotBicycle = [
            "all",
            MapTilerBaseLayerBase.IsOnewayFilter(),
            noOnewayBicycle
        ];
        const onewayReverseButNoBicycle = [
            "all",
            MapTilerBaseLayerBase.IsOnewayReverseFilter(),
            noOnewayBicycle
        ];
        const bicycleOnewayReverse = ["any",
            ["==", "anyways:oneway:bicycle", -1],
            ["all",
                ["!has", "anyways:oneway:bicycle"],
                ["==", "oneway:bicycle", -1]
            ],
            ["all",
                ["!has", "anyways:oneway:bicycle"],
                ["!has", "oneway:bicycle"],
                ["==", "oneway", -1]
            ]
        ];
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            paint: { "icon-opacity": 0.5 },
            layout: {
                "icon-image": "single-arrow",
                "icon-rotate": 0,
                "icon-padding": 2,
                "icon-size": 0.75,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map",
            },
            filter: bicycleOneway,
        }, "road_major_motorway");
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            paint: { "icon-opacity": 0.5 },
            layout: {
                "icon-image": "single-arrow",
                "icon-rotate": 180,
                "icon-padding": 2,
                "icon-size": 0.75,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map",
            },
            filter: bicycleOnewayReverse,
        }, "road_major_motorway");
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-not-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            paint: { "icon-opacity": 0.5 },
            layout: {
                "icon-image": "double-arrow",
                "icon-rotate": 0,
                "icon-padding": 2,
                "icon-size": 0.75,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map",
            },
            filter: onewayButNotBicycle,
        }, "road_major_motorway");
        MapTilerCyclingLayer.addLayer(style, {
            id: "bicycle-not-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            paint: { "icon-opacity": 0.5 },
            layout: {
                "icon-image": "double-arrow",
                "icon-rotate": 180,
                "icon-padding": 2,
                "icon-size": 0.75,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map",
            },
            filter: onewayReverseButNoBicycle,
        }, "road_major_motorway");
    }
}
MapTilerCyclingLayer.Url = "https://api.maptiler.com/maps/67ea3b5b-d4ac-48f3-ad92-6574c2dc9734/style.json?key=OZUCIh4RNx38vXF8gF4H";
